import { FC, PropsWithChildren } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectUiState, setUi } from 'store/uiSlice';

type LightingKnowledgeLinkType = PropsWithChildren & {
  id: string;
  sectionId?: string;
};

const LightingKnowledgeLink: FC<LightingKnowledgeLinkType> = ({
  id,
  sectionId,
  children,
}) => {
  const dispatch = useAppDispatch();
  const ui = useAppSelector(selectUiState) || {};

  function handleClick() {
    dispatch(
      setUi({
        ...ui,
        dashboard: {
          ...ui.dashboard,
          lightingKnowledge: {
            status: 'open',
            activeId: id,
            sectionId: sectionId,
          },
        },
      }),
    );
  }

  return (
    <div className="text-link" onClick={handleClick}>
      {children}
    </div>
  );
};

export default LightingKnowledgeLink;
